import { render, staticRenderFns } from "./FaqForm.vue?vue&type=template&id=4562d206"
import script from "./FaqForm.vue?vue&type=script&lang=js"
export * from "./FaqForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports